import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import TextAreaField from '../../../components/mobile/form-helpers/TextAreaField';

function MobileMultipleQuestionsSubmitTemplate({
  bodyStyle,
  question
}) {

  const { t } = useTranslation();

  return (
    <Box {...bodyStyle}>
      <TextAreaField rows={question.rows} name={question.value} placeholder={t(question.label)} />
    </Box>
  );
}

MobileMultipleQuestionsSubmitTemplate.defaultProps = {
  question: {},
  bodyStyle: {},
  titleStyle: {},
  selectStyling: {}
};

const { shape } = PropTypes;

MobileMultipleQuestionsSubmitTemplate.propTypes = {
  question: shape({}),
  selectStyling: shape({}),
  bodyStyle: shape({}),
  titleStyle: shape({}),
};

export default MobileMultipleQuestionsSubmitTemplate;
